import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Navbar         from './components/Navbar';
import Preloader      from './components/Preloader';
import Footer         from './components/Footer';
import CookieBanner   from './components/CookieBanner';
import ScrollToTop    from './components/ScrollToTop';
import Home           from './pages/Home';
import Shop           from './pages/Shop';
import ProductDetail  from './pages/ProductDetail';
import Compare        from './pages/Compare';
import About          from './pages/About';
import Services       from './pages/Services';
import Contact        from './pages/Contact';
import { ASZFPage, AdatvedelemPage } from './pages/LegalPages';
import Quiz from './pages/Quiz';
import CategoryLanding from './pages/CategoryLanding';
import KerekparBaja from './pages/KerekparBaja';
import ElektromosKerekparUtmutato from './pages/guides/ElektromosKerekparUtmutato';
import KerekparValasztas from './pages/guides/KerekparValasztas';

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Preloader />
      <Navbar />
      <Routes>
        <Route path="/"                      element={<Home />} />
        <Route path="/kerekparok"            element={<Shop />} />
        <Route path="/kerekparok/:slug"      element={<ProductDetail />} />
        <Route path="/osszehasonlitas"       element={<Compare />} />
        <Route path="/rolunk"                element={<About />} />
        <Route path="/szolgaltatasaink"      element={<Services />} />
        <Route path="/kapcsolat"             element={<Contact />} />
        <Route path="/aszf"                  element={<ASZFPage />} />
        <Route path="/adatvedelem"           element={<AdatvedelemPage />} />
        <Route path="/kviz"                  element={<Quiz />} />
        <Route path="/elektromos-kerekpar"   element={<CategoryLanding category="elektromos" />} />
        <Route path="/tura-kerekpar"         element={<CategoryLanding category="tura" />} />
        <Route path="/mtb-kerekpar"          element={<CategoryLanding category="mtb" />} />
        <Route path="/varosi-kerekpar"       element={<CategoryLanding category="varosi" />} />
        <Route path="/gyermek-kerekpar"      element={<CategoryLanding category="gyermek" />} />
        <Route path="/haromkereku-kerekpar"  element={<CategoryLanding category="haromkereku" />} />
        <Route path="/kerekpar-baja"         element={<KerekparBaja />} />
        <Route path="/elektromos-kerekpar-vasarlasi-utmutato" element={<ElektromosKerekparUtmutato />} />
        <Route path="/kerekpar-valasztas-utmutato"           element={<KerekparValasztas />} />
        <Route path="*"                      element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
  );
}
